import { LayoutService } from "./services/layout.service";
import { Component, OnInit, ChangeDetectorRef, AfterViewChecked } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
// MIGRATED: SecurityService y HttpBareClient de @ng-darwin/security sustituidos por
// OAuthService (@santander/security-angular) y HttpClient (@angular/common/http).
import { HttpClient } from "@angular/common/http";
import { OAuthService } from "@santander/security-angular";
import { LoggerService } from "@ng-darwin/logger";
import { DataService } from "./services/data.service";
import { ROUTE_PATH } from "../environments/environment";
import { NgIf } from "@angular/common";
import { HeaderComponent } from "./components/header/header.component";
import { AlertComponent } from "./components/alert/alert.component";
import { FooterComponent } from "./components/footer/footer.component";

@Component({
    selector: "prescp-root",
    templateUrl: "./app.component.html",
    imports: [NgIf, HeaderComponent, RouterOutlet, AlertComponent, FooterComponent]
})
export class AppComponent implements OnInit, AfterViewChecked {
  alertShow = false;
  headerShow = false;
  footerShow = false;
  alertOptions = {};
  background = '';
  claseBackground = "ps--full-image-container";
  backgroundSizer = "background-sizer-default";
  countDown = 0;
  response: any;

  /**
   * Several services are injected into the constructor for the examples
   * The only mandatory service is securityService if you want the token to be managed by Darwin
   */
  constructor(
    private readonly loggerService: LoggerService,
    private readonly httpBareClient: HttpClient,
    public layoutService: LayoutService,
    public dataService: DataService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly oauthService: OAuthService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    // THIS TWO LINES OF CODE ARE MANDATORY to manage the session and token:
    // - Subscription to session events (aboutToTimeout, timeout, resumed)
    // - Initialization of security service to manage the session and token
    // this._subcribeToSessionEvents();

    //  VERY IMPORTANT!!!
    //  PUT YOUR CODE HERE, AFTER SECURITY INITIALIZE PROMISE HAS BEEN FULLFILLED
    // **************************************************************************
    // this._logMessages();
    this.layoutSubscribers();
    this.backgroundMatch("");
    this.dataService.setFondoWcm('');
  }

  ngAfterViewChecked(){
    this.cdRef.detectChanges();
  }

  backgroundMatch(type: string): void {
    this.dataService.background$.subscribe((response: any) => {
      this.background = "";
      switch (response) {
        case "correos":
          this.claseBackground = "ps--full-image-container-correos";
          break;
        case "login":
          this.background = "../../assets/images/fondoLogin.jpg";
          break;
        case "mapfre":
          this.dataService.fondoWcm$.subscribe((response: any) => {
            this.background = response;
          });
          this.claseBackground = "ps--full-image-container-mapfre";
          this.backgroundSizer = "background-sizer-default";
          break;
        case "sinfondo":
          this.backgroundSizer = "ps--full-container";
          this.background = "";
          break;
        case "comerciales":
          this.dataService.fondoWcm$.subscribe((response: any) => {
            this.background = response;
          });
          this.claseBackground = "ps--full-image-container-comerciales";
          this.backgroundSizer = "background-sizer-custom";
          break;
        case "bp":
           this.dataService.fondoWcm$.subscribe((response: any) => {
            this.background = response;
          });
          this.claseBackground = "ps--full-image-container-bancaprivada";
          break;
        case "ra":
          this.background = "../../assets/images/fondoRentingAuto.jpg";
          this.backgroundSizer = "background-sizer-default";
          break;
        case "uv":
          this.background = "../../assets/images/fondoUniversidades.jpg";
          this.backgroundSizer = "background-sizer-default";
          break;
        case "dg":
          this.background = "../../assets/images/fondoDigital.jpg";
          this.backgroundSizer = "background-sizer-default";
          break;
        default:
          this.claseBackground = "ps--full-image-container";
          break;
      }
      this.cdRef.detectChanges();
    });
  }

  layoutSubscribers() {
    this.layoutService.alertOptions$.subscribe((options) => {
      this.alertOptions = options;
    });
    this.layoutService.alertIsShowed$.subscribe((show) => {
      this.alertShow = show;
    });
    this.layoutService.headerIsShowed$.subscribe((show) => {
      setTimeout(() => (this.headerShow = show));
    });
    this.layoutService.footerIsShowed$.subscribe((show) => {
      this.footerShow = show;
    });
  }

  /**
   * Method for a button click event inside the view
   */
  getRequestThroughHttpBareClient() {
    // Important: Note that this request through httpBareClientService has no interceptors. It's a bare request
    this.httpBareClient
      .get("/api/alive", { responseType: "text" })
      .subscribe((value: any) => {
        console.log("alive response:", value);
        this.response = value;
      });
  }

  /**
   * Method for a button click event inside the view
   */
  postRequestThroughLoggerService() {
    // Important: Note this request always have common headers if Security module has been loaded,
    // but only have auth header if 'logger.isSecure' property is true
    this.loggerService
      .logError({
        log: "my message to be logged",
        component: "mycomponent",
      })
      .then(() => {
        this.response =
          "Log enviado a fake Data Base. Se ha creado un nuevo registro en el fichero db.json";
      });
  }

  /**
   * Method for close session and clean credentials
   */
  closeSession() {
    // this.securityService.killSession();
    // OAuthService.logout() viene de OAuthHandler (sin tipos publicados); cast a any.
    Promise.resolve((this.oauthService as any).logout()).finally(() => {
      sessionStorage.clear();
      this.router.navigate([ROUTE_PATH.initCallback]);
    });
  }
}
